"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _imageCard = _interopRequireDefault(require("./image-card"));
var _iconCard = _interopRequireDefault(require("./icon-card"));
// TODO: CMS-28892: Remove this file entirely

function SWPFacadeCard(props) {
  const {
    cardType,
    ...rest
  } = props;
  switch (cardType) {
    case 'icon-card':
      return /*#__PURE__*/_react.default.createElement(_iconCard.default, rest);
    case 'image-card':
      return /*#__PURE__*/_react.default.createElement(_imageCard.default, rest);
    default:
      return null;
  }
}
SWPFacadeCard.propTypes = {
  cardType: _propTypes.default.oneOf(['icon-card', 'image-card']).isRequired
};
var _default = exports.default = SWPFacadeCard;